<modal
  [id]="modalId"
  [header]="'Support Request - ' + (event?.name || 'Event')"
  (onCloseModal)="onModalCloseEvent()"
  [widthClass]="'tw-w-[95vw]'"
  [heightClass]="'tw-h-[95vh]'"
  [showHeaderDivider]="true"
  [closeButtonEnabled]="true"
>
  <div slot="body" class="tw-h-full tw-flex tw-flex-row tw-overflow-hidden">
    <!-- Loading State -->
    @if (loading()) {
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-12 tw-w-full">
      <div class="spinner"></div>
      <p class="tw-mt-4 tw-text-gray-500">Loading event data...</p>
    </div>
    } @else {
    <!-- Two Column Layout -->
    <div class="tw-flex tw-flex-row tw-w-full tw-h-full tw-gap-0">
      <!-- Sidebar: Historical Requests (Left) -->
      <div class="tw-w-96 tw-flex-shrink-0 tw-flex tw-flex-col tw-border-r-2 tw-border-gray-200 tw-pr-6 tw-h-full tw-overflow-hidden">
        <div class="tw-flex tw-justify-between tw-items-center tw-mb-4 tw-pb-3 tw-border-b tw-border-gray-200">
          <h3 class="tw-text-lg tw-font-bold tw-text-gray-900 tw-m-0">Previous Requests</h3>
          @if (historicalRequests().length) {
          <span class="tw-bg-blue-500 tw-text-white tw-px-2 tw-py-1 tw-rounded-full tw-text-xs tw-font-semibold">{{ historicalRequests().length }}</span>
          }
        </div>

        <div class="tw-flex-1 tw-overflow-y-auto tw-pr-2 custom-scrollbar">
          <!-- Historical Requests -->
          @if (historicalRequests().length) {
          <div>
            <div class="tw-flex tw-flex-col tw-gap-3.5">
              @for (request of historicalRequests(); track request.id) {
              <div
                class="tw-border tw-rounded-lg tw-p-3.5 tw-bg-white tw-transition-all hover:tw-shadow-lg hover:tw--translate-y-0.5"
                [class.tw-bg-green-50]="request.fulfilled"
                [class.tw-border-green-300]="request.fulfilled"
                [class.tw-border-gray-200]="!request.fulfilled"
              >
                <div class="tw-flex tw-justify-between tw-items-center tw-mb-3">
                  <div
                    class="tw-px-3 tw-py-1.5 tw-rounded-md tw-text-xs tw-font-semibold tw-text-white"
                    [class.tw-bg-blue-500]="!request.fulfilled"
                    [class.tw-bg-green-500]="request.fulfilled"
                  >
                    {{ requestTypeLabels[request.type] }}
                  </div>
                  <label class="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-text-xs tw-font-medium tw-text-gray-700">
                    <input type="checkbox" [checked]="request.fulfilled" (change)="toggleFulfilled(request)" class="tw-cursor-pointer tw-w-4 tw-h-4" />
                    <span>Fulfilled</span>
                  </label>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-2.5">
                  <div class="tw-text-gray-700 tw-leading-relaxed tw-text-sm">
                    {{ getDescriptionPreview(request.description, 150) }}
                  </div>

                  <div class="tw-flex tw-flex-wrap tw-gap-3 tw-text-xs">
                    <div class="tw-flex tw-items-center tw-gap-1.5 tw-text-gray-600">
                      <svg viewBox="0 0 24 24" class="tw-w-3.5 tw-h-3.5">
                        <path
                          fill="currentColor"
                          d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"
                        />
                      </svg>
                      <span>{{ request.createdBy.name }}</span>
                    </div>
                    <div class="tw-flex tw-items-center tw-gap-1.5 tw-text-gray-600">
                      <svg viewBox="0 0 24 24" class="tw-w-3.5 tw-h-3.5">
                        <path
                          fill="currentColor"
                          d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1M17,12H12V17H17V12Z"
                        />
                      </svg>
                      <span>{{ formatDate(request.createdAt) }}</span>
                    </div>

                    @if (request.assignedTo) {
                    <div class="tw-flex tw-items-center tw-gap-1.5 tw-text-gray-600">
                      <svg viewBox="0 0 24 24" class="tw-w-3.5 tw-h-3.5">
                        <path
                          fill="currentColor"
                          d="M12,2A2,2 0 0,1 14,4C14,4.74 13.6,5.39 13,5.73V7H14A7,7 0 0,1 21,14H22A1,1 0 0,1 23,15V18A1,1 0 0,1 22,19H21V20A2,2 0 0,1 19,22H5A2,2 0 0,1 3,20V19H2A1,1 0 0,1 1,18V15A1,1 0 0,1 2,14H3A7,7 0 0,1 10,7H11V5.73C10.4,5.39 10,4.74 10,4A2,2 0 0,1 12,2Z"
                        />
                      </svg>
                      <span>Assigned to: {{ request.assignedTo }}</span>
                    </div>
                    }
                  </div>

                  @if(request.personas || request.fields){
                  <div class="tw-pt-2.5 tw-border-t tw-border-gray-200 tw-text-xs">
                    @if (request.personaNames && request.personaNames.length) {
                    <div class="tw-mb-1.5 tw-text-gray-700"><strong class="tw-text-gray-900 tw-mr-2">Personas:</strong>{{ request.personaNames.join(', ') }}</div>
                    } @if (request.fields && request.fields.length) {
                    <div class="tw-text-gray-700">
                      <strong class="tw-text-gray-900 tw-mr-2">Fields:</strong>
                      @for (field of request.fields; track field.name; let last = $last) {
                      <span> {{ field.personaName }} ({{ field.fieldNames.join(', ') }}){{ !last ? ', ' : '.' }} </span>
                      }
                    </div>
                    }
                  </div>
                  }
                </div>
              </div>
              }
            </div>
          </div>
          } @if (!historicalRequests().length) {
          <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-12 tw-text-gray-400 tw-text-center">
            <svg viewBox="0 0 24 24" class="tw-w-12 tw-h-12 tw-mb-4 tw-opacity-50">
              <path fill="currentColor" d="M19,3H5C3.9,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V5C21,3.9 20.1,3 19,3M19,19H5V5H19V19M17,12H7V14H17V12Z" />
            </svg>
            <p class="tw-m-0 tw-italic tw-text-sm">No previous support requests for this event</p>
          </div>
          }
        </div>
      </div>

      <!-- Main Content Area (Right) -->
      <div class="tw-flex-1 tw-flex tw-flex-col tw-gap-6 tw-overflow-y-auto tw-pl-6 tw-pr-2 tw-h-full custom-scrollbar">
        <!-- Event Info -->
        <div class="tw-flex tw-flex-wrap tw-gap-4 tw-p-4 tw-bg-gray-50 tw-rounded-lg tw-border tw-border-gray-200">
          <div class="tw-flex tw-gap-2">
            <span class="tw-font-semibold tw-text-gray-600">Event:</span>
            <span class="tw-text-gray-900">{{ event?.name }}</span>
          </div>
          <div class="tw-flex tw-gap-2">
            <span class="tw-font-semibold tw-text-gray-600">Slug:</span>
            <span class="tw-text-gray-900 tw-font-mono tw-bg-gray-200 tw-px-2 tw-py-0.5 tw-rounded tw-text-sm">{{ event?.slug }}</span>
          </div>
          <div class="tw-flex tw-gap-2">
            <span class="tw-font-semibold tw-text-gray-600">Workspace:</span>
            <span class="tw-text-gray-900">{{ event?.workspace?.name }}</span>
          </div>
        </div>

        <!-- Request Form -->
        <form [formGroup]="requestForm" class="tw-flex tw-flex-col tw-gap-5">
          <!-- Request Type -->
          <div class="tw-flex tw-flex-col tw-gap-2">
            <label class="tw-font-semibold tw-text-gray-900 tw-text-sm">Request Type <span class="tw-text-red-500 tw-ml-1">*</span></label>
            <select
              formControlName="type"
              class="tw-p-3 tw-border tw-border-gray-300 tw-rounded-lg tw-text-base tw-transition-colors focus:tw-outline-none focus:tw-border-blue-500 focus:tw-ring-4 focus:tw-ring-blue-100"
            >
              <option value="">Select a request type...</option>
              @for (type of requestTypes; track type) {
              <option [value]="type">
                {{ requestTypeLabels[type] }}
              </option>
              }
            </select>
          </div>

          <!-- Description Editor -->
          <div class="tw-flex tw-flex-col tw-gap-2">
            <div class="tw-flex tw-justify-between tw-items-center">
              <label class="tw-font-semibold tw-text-gray-900 tw-text-sm">Description <span class="tw-text-red-500 tw-ml-1">*</span></label>
              <span
                class="tw-text-xs tw-font-medium"
                [ngClass]="isDescriptionOverLimit() ? 'tw-text-red-500' : 'tw-text-gray-600'"
              >
                {{ descriptionCharCount() }} / {{ MAX_DESCRIPTION_LENGTH }}
              </span>
            </div>
         @if (editorKey()) {            
            <ngx-editor
              [message]="description()"
              (valueChange)="onDescriptionChange($event)"
              (characterCountChange)="onDescriptionCharacterCountChange($event)"
              [height]="300"
              [placeholder]="'Provide detailed information about the support request...'"
              [maxCharacterLimit]="MAX_DESCRIPTION_LENGTH"
            ></ngx-editor>
            }
            @if (isDescriptionOverLimit()) {
            <p class="tw-text-xs tw-text-red-500 tw-m-0 tw-mt-1">
              Description exceeds the maximum length of {{ MAX_DESCRIPTION_LENGTH }} characters. Please reduce the content to submit.
            </p>
            }
          </div>

          <!-- Persona Selection -->
          <div class="tw-flex tw-flex-col tw-gap-2">
            <label class="tw-font-semibold tw-text-gray-900 tw-text-sm">Personas (Optional)</label>
            <p class="tw-text-sm tw-text-gray-600 tw-m-0">Select the personas this request applies to</p>

            @if (loadingPersonas()) {
            <div class="tw-flex tw-items-center tw-gap-2 tw-p-4 tw-text-gray-600">
              <div class="small-spinner"></div>
              <span>Loading personas...</span>
            </div>
            } @else if (personas().length) {

            <div class="tw-flex tw-flex-col tw-gap-2 tw-max-h-80 tw-overflow-y-auto tw-p-2 tw-border tw-border-gray-200 tw-rounded-lg">
              @for (persona of personas(); track persona.slug) {
              <div
                class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-border tw-rounded-md tw-cursor-pointer tw-transition-all hover:tw-bg-gray-50 hover:tw-border-gray-300"
                [class.tw-bg-blue-50]="isPersonaSelected(persona.slug)"
                [class.tw-border-blue-500]="isPersonaSelected(persona.slug)"
                (click)="togglePersonaSelection(persona.slug)"
              >
                <input type="checkbox" [checked]="isPersonaSelected(persona.slug)" (click)="togglePersonaSelection(persona.slug); $event.stopPropagation()" class="tw-cursor-pointer" />
                <span class="tw-flex-1 tw-font-medium tw-text-gray-900">{{ persona.name }}</span>
                <span class="tw-text-sm tw-text-gray-600 tw-font-mono">{{ persona.slug }}</span>
              </div>
              }
            </div>
            } @else {
            <div class="tw-p-4 tw-text-center tw-text-gray-600 tw-italic">No personas found for this event</div>
            }
          </div>

          <!-- Field Selection -->
          @if (selectedPersonas().length) {
          <div class="tw-flex tw-flex-col tw-gap-2">
            <div class="tw-flex tw-justify-between tw-items-center">
              <label class="tw-font-semibold tw-text-gray-900 tw-text-sm">Fields (Optional)</label>
              <button
                type="button"
                class="tw-px-4 tw-py-2 tw-bg-gray-100 tw-border tw-border-gray-300 tw-rounded-md tw-text-sm tw-font-medium tw-text-gray-700 tw-cursor-pointer tw-transition-colors hover:tw-bg-gray-200"
                (click)="toggleFieldSelector()"
              >
                {{ showFieldSelector() ? 'Hide' : 'Show' }} Field Selector
              </button>
            </div>

            @if (showFieldSelector()) {
            <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-4">
              @for (personaSlug of selectedPersonas(); track personaSlug) {
              <div>
                <h4 class="tw-text-base tw-font-semibold tw-text-gray-900 tw-m-0 tw-mb-2">{{ getPersonaBySlug(personaSlug)?.name }}</h4>
                <div class="tw-flex tw-flex-col tw-gap-2 tw-max-h-80 tw-overflow-y-auto tw-p-2 tw-border tw-border-gray-200 tw-rounded-lg">
                  @for (field of getPersonaBySlug(personaSlug)?.form_elements; track field.name) {
                  <div
                    class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-border tw-rounded-md tw-cursor-pointer tw-transition-all hover:tw-bg-gray-50 hover:tw-border-gray-300"
                    [class.tw-bg-blue-50]="isFieldSelected(personaSlug, field.name)"
                    [class.tw-border-blue-500]="isFieldSelected(personaSlug, field.name)"
                    [class.tw-border-gray-200]="!isFieldSelected(personaSlug, field.name)"
                    (click)="toggleFieldSelection(personaSlug, getPersonaBySlug(personaSlug)!.name, field)"
                  >
                    <input type="checkbox" [checked]="isFieldSelected(personaSlug, field.name)" (click)="toggleFieldSelection(personaSlug, getPersonaBySlug(personaSlug)!.name, field);$event.stopPropagation()" class="tw-cursor-pointer" />
                    <span class="tw-flex-1 tw-font-medium tw-text-gray-900">{{ field.label }}</span>
                    <span class="tw-text-sm tw-text-gray-600 tw-font-mono">({{ field.name }})</span>
                  </div>
                  }
                </div>
              </div>
              }
            </div>
            }
          </div>
          }
          <!-- Submit Button -->
          <div class="tw-flex tw-gap-4 tw-justify-end tw-pt-6 tw-mt-auto tw-border-t-2 tw-border-gray-200">
            <button
              type="button"
              class="tw-px-8 tw-py-3 tw-bg-gray-100 tw-text-gray-700 tw-rounded-lg tw-font-semibold tw-cursor-pointer tw-transition-all tw-border tw-border-gray-300 hover:tw-bg-gray-200 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              (click)="closeModal()"
              [disabled]="submitting()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="tw-px-8 tw-py-3 tw-bg-blue-500 tw-text-white tw-rounded-lg tw-font-semibold tw-cursor-pointer tw-transition-all tw-shadow-md hover:tw-bg-blue-600 hover:tw-shadow-lg disabled:hover:tw-bg-blue-500 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
              (click)="submitRequest()"
              [disabled]="submitting() || requestForm.invalid || !description() || isDescriptionOverLimit()"
            >
              @if (submitting()) {
              <span class="tw-flex tw-items-center tw-gap-2">
                <div class="small-spinner"></div>
                Submitting... </span
              >}@else {
              <span>Submit Request</span>
              }
            </button>
          </div>
        </form>
      </div>
    </div>
    }
  </div>
</modal>
